// Layout of the Inbox (spec 08 § 1, D182): one list across organizations, no context of its own — the shell is the
// context the person was in last, with the Inbox tab current.
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppShell } from '../../shared/shell/AppShell'
import { useLastContext } from '../../shared/shell/lastContext'

export const Route = createFileRoute('/inbox')({
  // Guard (signed in): the session and access come from the query cache; a failed check redirects
  // to /sign-in?next=… or renders NotFound for an organization the person is not in (spec 08 § 5).
  beforeLoad: () => {},
  staticData: { workspace: 'me' },
  component: InboxLayout,
})

function InboxLayout() {
  const context = useLastContext()
  return (
    <AppShell {...context}>
      <Outlet />
    </AppShell>
  )
}
